/**
 * --------------------------------------------------------------------------
 * Basic Modules: Clickable.js
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'clickable';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const Selector = {
    TOGGLE              : '.js-clickable',
};

class Clickable {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this._element = element;
        this._config  = this._getConfig(config);

        this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _handleClick(event) {
        let $this = $(event.currentTarget);
        window.location.href = $this.data('href');
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _addEventListeners() {
        $(this._element).on(Event.CLICK, (event) => this._handleClick(event));
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        Clickable._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new Clickable(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = Clickable._jQueryInterface;
$.fn[NAME].Constructor = Clickable;


export default Clickable;
